import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/services/loader/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  isLoading: Subject<boolean> = this._loaderService.isLoading;
  isPageLoading: Subject<boolean> = this._loaderService.isPageLoading;
  
  constructor(private _loaderService: LoaderService) { }

  ngOnInit(): void {
  }

}
